import Vue from 'vue';
import { mapActions } from 'vuex';
import { LOAD_PROJECT } from 'src/store/types';
import Project from "src/api/project";
import { BfSpinner } from 'components/Butterfly';
export default Vue.extend({
    components: { BfSpinner },
    beforeRouteLeave(to, from, next) {
        this.safeClearTimeout();
        // null indicates teardown is active. The timeout will not be reset.
        this.refreshTimeout = null;
        next();
    },
    props: {
        projectId: { type: Number, required: true }
    },
    data() {
        return {
            // This default is intentionally undefined. During teardown, this will
            // be set to null and various promises' callbacks will check for
            // null to know whether we're in a teardown state.
            refreshTimeout: undefined,
            projectError: null,
            showLoader: true,
            projectLoadStartTime: null,
            isLoading: false, // is a request for project data in progress ?
        };
    },
    watch: {
        projectId: function (newId, oldId) {
            if (newId !== oldId) {
                this.showLoader = true;
                this.fetchProject();
            }
        }
    },
    mounted() {
        this.fetchProject();
    },
    beforeDestroy() {
        this.safeClearTimeout();
        // null indicates teardown is active. The timeout will not be reset.
        this.refreshTimeout = null;
    },
    methods: {
        ...mapActions({ LOAD_PROJECT }),
        async fetchProject() {
            // If null, we're in teardown
            if (this.refreshTimeout === null)
                return;
            // We're inside the method that was fired from the timeout, so
            // let's clean up the timeout ID that brought us here.
            this.safeClearTimeout();
            // If there's no project id, we've navigated somewhere else
            if (!this.projectId)
                return;
            try {
                this.projectLoadStartTime = new Date();
                this.isLoading = true;
                await this.LOAD_PROJECT({
                    projectId: this.projectId,
                    rethrowErrors: true
                });
                this.projectError = null;
                // If the timeout ID is null, we're in teardown (it could have
                // started during the `await` above).
                //
                // If the timeout is a valid ID, then something else set the timeout
                // so we will allow that call to fire and do nothing here. We
                // only set a new timeout here if no timeout is currently set, and
                // we identify that by the `undefined` value.
                if (this.refreshTimeout === undefined) {
                    this.refreshTimeout = setTimeout(this.fetchProject, Project.REFRESH_INTERVAL);
                }
            }
            catch (error) {
                this.projectError = error;
            }
            finally {
                this.isLoading = false;
                this.delayedLoaderHide();
            }
        },
        safeClearTimeout() {
            clearTimeout(this.refreshTimeout);
            this.refreshTimeout = undefined;
        },
        delayedLoaderHide() {
            // ensure that loader is shown for at least one second
            const diff = (new Date()).valueOf() - this.projectLoadStartTime.valueOf();
            const delay = diff > 1000 ? 0 : 1000 - diff;
            setTimeout(() => {
                this.showLoader = false;
            }, delay);
        }
    }
});
